<template>
    <div class="doctor">
        <b-form-row>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="First Name"
                        label-for="">
                    <b-form-input name="first_name" v-validate="'required|alpha_spaces'"
                                  v-model="doctor.first_name"></b-form-input>
                    <span class="error">{{ errors.first('first_name') }}</span>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Last Name"
                        label-for="">
                    <b-form-input name="last_name" v-validate="'required|alpha_spaces'"
                                  v-model="doctor.last_name"></b-form-input>
                    <span class="error">{{ errors.first('last_name') }}</span>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Middle Name"
                        label-for="">
                    <b-form-input name="middle_name" v-model="doctor.middle_name"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="License Number"
                        label-for="">
                    <b-form-input name="license_number" v-validate="'required'"
                                  v-model="doctor.license_number"></b-form-input>
                    <span class="error">{{ errors.first('license_number') }}</span>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Ptr Number"
                        label-for="">
                    <b-form-input name="ptr_number" v-validate="'required'" v-model="doctor.ptr_number"></b-form-input>
                    <span class="error">{{ errors.first('ptr_number') }}</span>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Field"
                        label-for="">
                    <b-form-input name="field" v-validate="'required'" v-model="doctor.field"></b-form-input>
                    <span class="error">{{ errors.first('field') }}</span>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-row>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Year of Service"
                        label-for="">
                    <b-form-input name="year_of_service" v-validate="'required|numeric'"
                                  v-model="doctor.year_of_service"></b-form-input>
                    <span class="error">{{ errors.first('year_of_service') }}</span>
                </b-form-group>
            </b-col>
        </b-form-row>


        <b-form-row>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Clinic Name"
                        label-for="">
                    <b-form-input name="clinic_name" v-validate="'required'"
                                  v-model="doctor.clinic_name"></b-form-input>
                    <span class="error">{{ errors.first('clinic_name') }}</span>
                </b-form-group>
            </b-col>
            <b-col sm="12" lg="6">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Clinic Address"
                        label-for="">
                    <b-form-input name="clinic_name" v-validate="'required'"
                                  v-model="doctor.clinic_address"></b-form-input>
                    <span class="error">{{ errors.first('clinic_name') }}</span>
                </b-form-group>
            </b-col>
        </b-form-row>

    </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    data() {
      return {
        doctor: {}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Doctor/DoctorAdd.vue